import { Model3DLevel } from "../objects/baseGraphData";
import { InteractableType } from "../objects/trafficInteractable";

export function shouldShowGraph(
    selectedDirectory: { [key: string]: string },
    selectedInteractable: InteractableType,
    nextLevel: Model3DLevel,
    excludedDirectory?: Model3DLevel
): boolean {
    if (selectedInteractable?.type !== 'gate') return false;
    if (!excludedDirectory) return true;
    if (selectedDirectory.floor === 'ALL')
        return true;
    if (excludedDirectory === 'FLOOR_AND_ZONE')
        return false;
    return nextLevel !== excludedDirectory;
}

export function safeGet<T>(obj: any, path: (string | undefined)[], defaultValue: T): T {
    return path.reduce(
        (o, key) => (o != null && key != null ? o[key] : undefined),
        obj
    ) ?? defaultValue;
}